import { render, staticRenderFns } from "./liveCard.vue?vue&type=template&id=50a1ed1d&scoped=true"
import script from "./liveCard.vue?vue&type=script&lang=js"
export * from "./liveCard.vue?vue&type=script&lang=js"
import style0 from "./liveCard.vue?vue&type=style&index=0&id=50a1ed1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a1ed1d",
  null
  
)

export default component.exports